module.exports = __webpack_public_path__ + "static/media/banner-beneficios.ac6b5eaf.png";